export abstract class ValidationRegExp {
    
    /**
     * Regular expression for uppercase letters (checks if any uppercase letter exists in the string)
     */
    public static readonly UPPERCASE_REGEXP = /[A-Z]/;
    /**
     * Regular expression for lowercase letters (checks if any lowercase letter exists in the string)
     */
    public static readonly LOWERCASE_REGEXP = /[a-z]/;
    /**
     * Regular expression for numbers (checks if any number exists in the string)
     */
    public static readonly NUMBERS_REGEXP = /[0-9]/;

    /**
     * Regular expression for symbols (checks if any symbol exists in the string)
     */
    public static readonly SYMBOLS_REGEXP = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    /**
     * Regular expression for all letters, numbers and symbols (checks if any valid password character exists in the string)
     */
    public static readonly PASSWORD_REGEXP = /[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    /**
     * Checks if the string contains at least one uppercase letter
     * @param value - The string to check
     * @returns true if at least one uppercase letter exists
     */
    public static atLeastOneUpper(value: string): boolean {
        return this.UPPERCASE_REGEXP.test(value);
    }

    /**
     * Checks if the string contains at least one lowercase letter
     * @param value - The string to check
     * @returns true if at least one lowercase letter exists
     */
    public static atLeastOneLower(value: string): boolean {
        return this.LOWERCASE_REGEXP.test(value);
    }

    /**
     * Checks if the string contains at least one number
     * @param value - The string to check
     * @returns true if at least one number exists
     */
    public static atLeastOneNumber(value: string): boolean {
        return this.NUMBERS_REGEXP.test(value);
    }

    /**
     * Checks if the string contains at least one symbol
     * @param value - The string to check
     * @returns true if at least one symbol exists
     */
    public static atLeastOneSymbol(value: string): boolean {
        return this.SYMBOLS_REGEXP.test(value);
    }

}
